import { Box, Divider, Grid, Typography } from "@mui/material";

interface IFormTitleProps {
    title: string
    margin?: number
}

export const FormTitleSession: React.FC<IFormTitleProps> = ({ title, margin=0 }) => {
  return (
    <Grid item xs={12}>
        <Box display="flex" alignItems="center" width="100%" marginTop={margin}>
        <Typography
            variant="caption"
            color="#1E62FE"
            fontSize={24}
            fontWeight={600}
            sx={{ whiteSpace: "nowrap", marginRight: 1 }}
        >
            {title}
        </Typography>
        <Divider
            sx={{ borderColor: "#1E62FE", flexGrow: 1 }}
        />
        </Box>
    </Grid>
  );
};